type GoogleIdentity = {
  initialize: (config: { client_id: string; callback: (response: { credential: string }) => void; auto_select: boolean }) => void;
  renderButton: (element: HTMLElement, options: Record<string, unknown>) => void;
  cancel: () => void;
};
type SocialWindow = Window & {
  google?: { accounts: { id: GoogleIdentity } };
};
const scripts = new Map<string, Promise<void>>();
function loadScript(id: string, src: string, ready: () => boolean) {
  if (ready()) return Promise.resolve();
  const pending = scripts.get(id);
  if (pending) return pending;
  const promise = new Promise<void>((resolve, reject) => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    const owned = !script;
    script ??= document.createElement('script');
    const timeout = window.setTimeout(failed, 15000);
    function cleanup() {
      clearTimeout(timeout);
      script?.removeEventListener('load', loaded);
      script?.removeEventListener('error', failed);
    }
    function failed() { cleanup(); if (owned) script?.remove(); reject(new Error('Sign in provider could not load. Please retry or use email.')); }
    function loaded() { if (!ready()) return failed(); cleanup(); resolve(); }
    script.addEventListener('load', loaded, { once: true });
    script.addEventListener('error', failed, { once: true });
    if (owned) { script.id = id; script.src = src; script.async = true; document.head.appendChild(script); }
  });
  scripts.set(id, promise);
  void promise.catch(() => scripts.delete(id));
  return promise;
}
export async function loadGoogle() {
  const win = window as SocialWindow;
  await loadScript('google-gsi-script', 'https://accounts.google.com/gsi/client', () => Boolean(win.google?.accounts.id));
  return win.google!.accounts.id;
}
